/* Arelio Umbrella: countdowns, before/after sliders, centre-focus carousels, offer cards, card add-to-cart and menu dropdowns.
   Runs after ac-core.js and uses window.Arelio (Cart, formatMoney, toast, track). */
(function () {
  'use strict';
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const A = () => window.Arelio || {};
  const S = (window.ArelioConfig || {}).strings || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Countdown to a real end date (hidden when there is none or it has passed) ---------- */
  function parseEnd(text) {
    const m = String(text || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    const d = new Date(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 59);
    return isNaN(d) ? null : d;
  }
  const pad = (n) => String(n).padStart(2, '0');
  function initCountdowns(root = document) {
    $$('[data-countdown]', root).forEach((el) => {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      const end = parseEnd(el.dataset.countdown);
      const out = $('[data-countdown-time]', el);
      if (!end || !out) return;
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { el.hidden = true; clearInterval(timer); return; }
        const s = Math.floor(left / 1000);
        const d = Math.floor(s / 86400);
        const h = Math.floor((s % 86400) / 3600);
        out.textContent = (d > 0 ? d + (S.days || 'd') + ' ' : '') + pad(h) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
        el.hidden = false;
      };
      const timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Before / after ---------- */
  function initBeforeAfter(root = document) {
    $$('[data-before-after]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const range = $('[data-before-after-range]', wrap);
      if (!range) return;
      const set = (v) => wrap.style.setProperty('--pos', v + '%');
      range.addEventListener('input', () => set(range.value));
      set(range.value);
    });
  }

  /* ---------- Centre-focus carousel ---------- */
  function initFocus(root = document) {
    $$('[data-focus-carousel]', root).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const track = $('[data-focus-track]', wrap);
      const cards = $$('[data-focus-card]', wrap);
      const dots = $$('[data-focus-dots] .ac-dot', wrap);
      if (!track || !cards.length) return;
      const activate = (i) => {
        cards.forEach((c, n) => c.classList.toggle('is-active', n === i));
        dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
      };
      const nearest = () => {
        const mid = track.getBoundingClientRect().left + track.clientWidth / 2;
        let best = 0; let dist = Infinity;
        cards.forEach((c, n) => { const r = c.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); if (d < dist) { dist = d; best = n; } });
        return best;
      };
      let raf;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => activate(nearest())); }, { passive: true });
      const go = (i) => {
        const c = cards[i]; if (!c) return;
        track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      cards.forEach((c, i) => c.addEventListener('click', () => { if (!c.classList.contains('is-active')) go(i); }));
      requestAnimationFrame(() => activate(nearest()));
    });
  }

  /* ---------- Offer cards: pick the pack in the main buy box, then add (or send the shopper to choose each item) ---------- */
  function initOfferCards(root = document) {
    $$('[data-offer-cards]', root).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      sec.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-offer-qty]');
        if (!btn) return;
        const qty = parseInt(btn.dataset.offerQty, 10);
        const main = $('[data-main-product]');
        const boxEl = main && $('[data-buy-box]', main);
        const box = boxEl && boxEl._buybox;
        if (!box) { if (main) main.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }); return; }
        const input = $(`[data-pack-input][value="${qty}"]`, boxEl);
        if (input) { input.checked = true; box.selectPack(qty); }
        /* Products with sizes: if no size was picked yet, take the shopper to the size choice instead of guessing. */
        const hasOptions = $$('[data-option-group]', boxEl).length > 0;
        if ((hasOptions && !box.touched) || !box.state || !box.state.ok) {
          const target = $('[data-option-group]', boxEl) || main;
          boxEl.classList.add('needs-size');
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          if (hasOptions && !box.touched && A().toast) A().toast(S.pickSize || 'Choose your size first');
          return;
        }
        const checkout = sec.dataset.action === 'checkout';
        await box.addToCart({ checkout, button: btn, source: 'offer_cards' });
      });
    });
  }

  /* ---------- Add to cart on product cards (single-variant products) ---------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-card-add]');
    if (!btn || !A().Cart) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try { await A().Cart.add([{ id: parseInt(btn.dataset.cardAdd, 10), quantity: 1 }], { source: 'product_card' }); }
    catch (err) { if (A().toast) A().toast(err.message, 'error'); }
    btn.removeAttribute('aria-busy');
  });

  /* ---------- Desktop menu dropdowns: one open at a time, close on outside click or Escape ---------- */
  function initNavDrops() {
    const drops = $$('[data-nav-drop]');
    if (!drops.length) return;
    drops.forEach((d) => d.addEventListener('toggle', () => { if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; }); }));
    document.addEventListener('click', (e) => { drops.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') drops.forEach((d) => { if (d.open) { d.open = false; const s = $('summary', d); if (s) s.focus(); } }); });
  }

  /* ---------- Exit offer: once per visitor, on desktop exit intent or the first back press on a phone ---------- */
  const EXIT_KEY = 'ac_exit_offer_seen';
  const lsGet = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked: the offer may show again next visit */ } };
  function initExitOffer() {
    const modal = $('[data-exit-offer]');
    if (!modal || !A().Overlay) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (/\/(cart|checkout|account|challenge)/.test(location.pathname)) return;
    if (lsGet(EXIT_KEY)) return;
    const code = modal.dataset.code;
    const minMs = (parseInt(modal.dataset.min, 10) || 0) * 1000;
    const start = Date.now();
    let shown = false;
    const otherOverlayOpen = () => document.body.classList.contains('ac-scroll-lock');
    const show = (source) => {
      if (shown || lsGet(EXIT_KEY) || Date.now() - start < minMs) return false;
      if (otherOverlayOpen()) { const open = $('.ac-modal.is-open, .ac-drawer.is-open'); if (open && open.id === 'EmailPopup') A().Overlay.close(open); else return false; }
      shown = true;
      lsSet(EXIT_KEY, String(Date.now()));
      A().Overlay.open(modal);
      if (A().track) A().track('exit_offer_shown', { source });
      return true;
    };

    if (modal.dataset.desktop === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', (e) => { if (!e.relatedTarget && e.clientY <= 0) show('desktop_exit'); });
    }

    /* Phone back button: after the first tap we add one history entry for this page. The first back press shows the offer;
       the next back press leaves as normal, so nobody is trapped. Hash jumps and collection filters are not treated as leaving. */
    if (modal.dataset.mobile === 'true' && window.matchMedia('(hover: none)').matches && history.pushState) {
      let armed = false;
      const arm = () => {
        if (armed || shown || lsGet(EXIT_KEY)) return;
        armed = true;
        history.pushState({ acExit: true }, '', location.href);
      };
      ['touchend', 'click'].forEach((ev) => document.addEventListener(ev, arm, { once: true, passive: true, capture: true }));
      window.addEventListener('popstate', (e) => {
        if (!armed || shown) return;
        const st = e.state;
        if (st && (st.acExit || st.filters)) return;
        if (!show('mobile_back')) history.back();
      });
    }

    modal.addEventListener('click', async (e) => {
      if (e.target.closest('[data-exit-copy]')) {
        const btn = e.target.closest('[data-exit-copy]');
        try { await navigator.clipboard.writeText(code); btn.textContent = S.copied || 'Copied'; }
        catch (err) { const r = document.createRange(); r.selectNodeContents($('[data-exit-code]', modal)); const s = getSelection(); s.removeAllRanges(); s.addRange(r); }
      }
      if (e.target.closest('[data-exit-apply]')) {
        const btn = e.target.closest('[data-exit-apply]');
        btn.setAttribute('aria-busy', 'true');
        try { await fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js'), { credentials: 'same-origin' }); } catch (err) { /* the code is still shown to copy */ }
        btn.removeAttribute('aria-busy');
        btn.hidden = true;
        const done = $('[data-exit-done]', modal); if (done) done.hidden = false;
        if (A().track) A().track('exit_offer_applied', { code });
        setTimeout(() => A().Overlay.close(modal), 1800);
      }
    });
  }

  /* ---------- Delivery dates: worked out from the visitor's today, so they never go stale ---------- */
  function addBusinessDays(date, n) {
    const d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function initEta(root = document) {
    $$('[data-eta]', root).forEach((el) => {
      const out = $('[data-eta-text]', el);
      if (!out) return;
      const country = (window.Shopify && Shopify.country) || '';
      const locale = country === 'US' ? 'en-US' : 'en-GB';
      const day = (d) => d.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric' });
      const short = (d) => d.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
      const ship = addBusinessDays(new Date(), parseInt(el.dataset.dispatch, 10) || 0);
      const from = new Date(ship); from.setDate(from.getDate() + (parseInt(el.dataset.min, 10) || 0));
      const to = new Date(ship); to.setDate(to.getDate() + (parseInt(el.dataset.max, 10) || 0));
      out.textContent = (el.dataset.text || '').replace('[ship]', day(ship)).replace('[from]', short(from)).replace('[to]', short(to));
      el.hidden = false;
    });
  }

  /* ---------- Video row: silent previews while on screen; a tap opens the full-screen player with sound ---------- */
  function initVideos(root = document) {
    $$('[data-vids]', root).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const cards = $$('[data-vids-card]', sec);
      const modal = $('[data-vids-modal]', sec);
      if (!cards.length || !modal) return;
      const track = (name, data) => { if (A().track) A().track(name, Object.assign({ product_id: sec.dataset.productId }, data)); };

      /* Previews load nothing until they scroll into view, then loop silently while at least 60% visible.
         Browsers that play HLS get Shopify's adaptive stream, which uses less data on slow connections. */
      const canHls = !!document.createElement('video').canPlayType('application/vnd.apple.mpegurl');
      const previews = cards.map((c) => $('video', c));
      const visible = new Set();
      const playPreview = (v) => { if (!v.getAttribute('src')) v.src = (canHls && v.dataset.hls) || v.dataset.src; const p = v.play(); if (p) p.catch(() => {}); };
      const saveData = navigator.connection && navigator.connection.saveData;
      if (sec.dataset.autoplay === 'true' && !reduceMotion && !saveData && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => entries.forEach((e) => {
          if (e.isIntersecting) { visible.add(e.target); if (!modal.classList.contains('is-open')) playPreview(e.target); }
          else { visible.delete(e.target); e.target.pause(); }
        }), { threshold: 0.6 });
        previews.forEach((v) => io.observe(v));
      }

      const player = $('[data-vids-player]', modal);
      const toggle = $('[data-vids-toggle]', modal);
      const muteBtn = $('[data-vids-mute]', modal);
      const prev = $('[data-vids-prev]', modal);
      const next = $('[data-vids-next]', modal);
      const bars = $$('.ac-vplayer__bar i', modal);
      const L = modal.dataset;
      let index = 0;
      let muted = false;
      let swiped = false;

      const setMuted = (m) => {
        muted = m;
        player.muted = m;
        modal.classList.toggle('is-muted', m);
        muteBtn.setAttribute('aria-pressed', String(m));
        muteBtn.setAttribute('aria-label', m ? L.unmuteLabel : L.muteLabel);
      };
      const setPaused = (p) => { modal.classList.toggle('is-paused', p); toggle.setAttribute('aria-label', p ? L.playLabel : L.pauseLabel); };
      const fillBars = () => bars.forEach((b, i) => {
        const now = player.duration ? (player.currentTime / player.duration) * 100 : 0;
        b.style.width = (i < index ? 100 : i > index ? 0 : now) + '%';
      });
      /* Sound is allowed after a tap; if the browser still refuses, play muted and show the sound button as off.
         An AbortError only means the next video was loaded before this one started, so it is ignored. */
      const start = () => {
        const p = player.play();
        if (p) p.catch((err) => {
          if (err && err.name === 'AbortError') return;
          if (player.muted) { setPaused(true); return; }
          setMuted(true);
          player.play().catch(() => setPaused(true));
        });
      };
      const go = (i) => {
        if (i < 0 || i >= cards.length) return;
        index = i;
        const c = cards[i].dataset;
        player.poster = c.poster || '';
        player.src = canHls && c.hls ? c.hls : c.mp4;
        player.muted = muted;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === cards.length - 1;
        /* A button that just hid would drop keyboard focus out of the player. */
        if (document.activeElement && document.activeElement.disabled) toggle.focus({ preventScroll: true });
        fillBars();
        start();
      };

      cards.forEach((card, i) => card.addEventListener('click', () => {
        previews.forEach((v) => v.pause());
        setMuted(false);
        A().Overlay.open(modal, card);
        go(i);
        track('video_open', { index: i + 1 });
      }));
      player.addEventListener('timeupdate', fillBars);
      player.addEventListener('play', () => setPaused(false));
      player.addEventListener('pause', () => setPaused(true));
      player.addEventListener('ended', () => {
        track('video_complete', { index: index + 1 });
        if (index < cards.length - 1) go(index + 1);
      });
      toggle.addEventListener('click', () => {
        if (swiped) { swiped = false; return; }
        if (player.paused) start(); else player.pause();
      });
      muteBtn.addEventListener('click', () => { setMuted(!muted); if (player.paused) start(); });
      if (prev) prev.addEventListener('click', () => go(index - 1));
      if (next) next.addEventListener('click', () => go(index + 1));

      /* Swipe left or right for the next or previous video; the tap that ends a swipe does not pause. */
      let sx = 0; let sy = 0;
      modal.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      modal.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - sx;
        const dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy)) return;
        swiped = true;
        setTimeout(() => { swiped = false; }, 400);
        go(index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      document.addEventListener('keydown', (e) => {
        if (!modal.classList.contains('is-open')) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });

      /* Buy now: close the player and jump to the pack choice, like the sticky bar, so the shopper still picks a size. */
      const buy = $('[data-vids-buy]', modal);
      if (buy) buy.addEventListener('click', () => {
        track('video_buy_now', { index: index + 1 });
        A().Overlay.close(modal);
        const main = $('[data-main-product]');
        const box = main && $('[data-buy-box]', main);
        const target = (box && ($('[data-packs]', box) || $('[data-option-group]', box))) || box || main;
        if (target) setTimeout(() => target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }), 50);
      });

      modal.addEventListener('overlay:close', () => {
        player.pause();
        player.removeAttribute('src');
        player.load();
        visible.forEach(playPreview);
      });
    });
  }

  function boot(root = document) {
    initCountdowns(root);
    initBeforeAfter(root);
    initFocus(root);
    initOfferCards(root);
    initEta(root);
    initVideos(root);
  }
  function start() {
    boot();
    initNavDrops();
    initExitOffer();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    /* The cart drawer is re-rendered after each change; fill its delivery line again. */
    document.addEventListener('arelio:cart-updated', () => setTimeout(() => initEta(), 0));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
